import * as Actions from '../../../Modules/CmsActions'
import type { IPagination } from '../../../Types'

interface State {
  loading: boolean
  edit: null | any
  list: Array<{ name: string; downloadURL: string }>
  pagination: IPagination
}

const initialState: State = {
  loading: true,
  edit: null,
  list: [],
  pagination: {
    current_page: 1,
    first_page_url: null,
    from: 0,
    last_page: 1,
    last_page_url: null,
    next_page_url: null,
    path: null,
    per_page: 15,
    prev_page_url: null,
    to: 0,
    total: 0,
  },
}

const UIRedirectionReducer = (state: State = initialState, action) => {
  const { type, payload, error } = action

  switch (type) {
    case Actions.REQUEST_FETCH_ALL_REDIRECTION:
      return { ...state, loading: true }

    case Actions.FINISH_FETCH_ALL_REDIRECTION:
      return error
        ? { ...state, loading: false }
        : {
            ...state,
            loading: false,
            list: payload.redirection,
            pagination: payload.pagination,
          }

    case Actions.REQUEST_FETCH_REDIRECTION:
      return { ...state, loading: true }

    case Actions.FINISH_FETCH_REDIRECTION:
      return { ...state, loading: false, edit: payload.redirection }

    case Actions.UNLOAD_REDIRECTION:
      return { ...state, edit: null }

    case Actions.REQUEST_UPDATE_REDIRECTION:
      return { ...state, loading: true }

    case Actions.FINISH_UPDATE_REDIRECTION:
      return { ...state, loading: false }

    case Actions.REQUEST_DELETE_REDIRECTION:
      return { ...state, loading: true }

    case Actions.FINISH_DELETE_REDIRECTION:
      return { ...state, loading: false }

    default:
      return state
  }
}

export default UIRedirectionReducer
